import * as React from "react";
import { useContext, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import ListItem from "./listItem/ListItem";
import List from "@mui/material/List";
import useContent from "./listItem/useContent";
import CollapseItem from "./listItem/CollapseItem";
import { AdminDataContext } from "../../useContext/AdminContext";
import Avatar from "@mui/material/Avatar";
import { Typography } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";

import { imgUrl } from "../../url";
const drawerWidthExpanded = 200;
const drawerWidthCollapsed = 60;

function LeftDrawer(props) {
  const Content = useContent();
  const [expanded, setExpanded] = React.useState("");
  const [isDrawerExpanded, setIsDrawerExpanded] = React.useState(true);

  const handleExpandChange = (index) => () => {
    if (expanded[index] === true) {
      setExpanded({ [index]: false });
    } else {
      setExpanded({ [index]: true });
    }
  };
  const { window: windowProp } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const { adminData } = useContext(AdminDataContext);
  // console.log("adminData", adminData);

  // Handle responsive behavior on window resize
  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== "undefined" && window.innerWidth >= 600) {
        // Close mobile drawer when resizing to desktop
        setMobileOpen(false);
      }
    };

    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const handleDrawerToggle = () => {
    if (typeof window !== "undefined" && window.innerWidth < 600) {
      // Mobile behavior (below 600px)
      setMobileOpen(!mobileOpen);
    } else {
      // Desktop/Tablet behavior - toggle between expanded and collapsed
      setIsDrawerExpanded(!isDrawerExpanded);
    }
  };

  const drawerWidth = isDrawerExpanded
    ? drawerWidthExpanded
    : drawerWidthCollapsed;

  const mobileDrawer = (
    <div>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          my: 2,
        }}
      >
        <Box
          sx={{
            width: "80%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img className="logo" title="DrLam" src="/images/DrLamLogo.webp" />
        </Box>
        {/* <IconButton
          onClick={handleDrawerToggle}
          sx={{
            position: "absolute",
            top: 0,
            right: 8,
            color: "#fff",
            "&:hover": {
              backgroundColor: "transparent",
              color: "#00739b",
            },
          }}
        >
          <CloseIcon />
        </IconButton> */}
      </Box>
      <List>
        {Content.map((data, index) => {
          return (
            <div key={index}>
              {data.items ? (
                <CollapseItem
                  key={index}
                  setMobileOpen={setMobileOpen}
                  expanded={expanded}
                  handleExpandChange={handleExpandChange}
                  data={data}
                  index={index}
                  isDrawerExpanded={true}
                />
              ) : (
                <ListItem
                  key={index}
                  setMobileOpen={setMobileOpen}
                  setExpanded={setExpanded}
                  data={data}
                  isDrawerExpanded={true}
                />
              )}
            </div>
          );
        })}
      </List>
    </div>
  );

  const desktopDrawer = (
    <div>
      {isDrawerExpanded && (
        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            my: 2,
          }}
        >
          <Box
            sx={{
              width: "80%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img width="100%" title="DrLam" src="/images/DrLamLogo.webp" />
          </Box>
        </Box>
      )}
      <List>
        {Content.map((data, index) => {
          return (
            <div key={index}>
              {data.items ? (
                <CollapseItem
                  key={index}
                  setMobileOpen={setMobileOpen}
                  expanded={expanded}
                  handleExpandChange={handleExpandChange}
                  data={data}
                  index={index}
                  isDrawerExpanded={isDrawerExpanded}
                />
              ) : (
                <ListItem
                  key={index}
                  setMobileOpen={setMobileOpen}
                  setExpanded={setExpanded}
                  data={data}
                  isDrawerExpanded={isDrawerExpanded}
                />
              )}
            </div>
          );
        })}
      </List>
    </div>
  );

  const container =
    windowProp !== undefined ? () => windowProp().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        color="white"
        position="fixed"
        sx={{
          width: "100%",
          backgroundColor: "primary.main",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="toggle drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              mr: 2,
              display: { xs: mobileOpen ? "none" : "block", sm: "block" },
              color: "#fff",
            }}
          >
            <MenuIcon sx={{ color: "#fff" }} />
          </IconButton>

          <Box sx={{ flexGrow: 1 }} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            {adminData.photo ? (
              <Avatar
                src={`${imgUrl}/${adminData.photo}`}
                sx={{
                  width: 30,
                  height: 30,
                  border: "1px solid #fff",
                }}
              />
            ) : (
              <Avatar
                sx={{
                  // width: 30,
                  // height: 30,
                  width: { xs: 25, md: 30 },
                  height: { xs: 25, md: 30 },
                  bgcolor: "primary.main",
                  border: "1px solid #fff",
                }}
              >
                <PersonIcon />
              </Avatar>
            )}
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: "0.855rem", md: "1rem" },
                fontWeight: 500,
                // display: { xs: "none", sm: "block" },
              }}
            >
              {adminData?.fullName || "User"}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{
          width: { xs: 0, sm: drawerWidth },
          flexShrink: 0,
        }}
        aria-label="mailbox folders"
      >
        {/* Mobile Drawer - Overlay (Below 600px) */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          PaperProps={{
            sx: {
              backgroundColor: "drawerColor.main",
              marginTop: { xs: "0px", sm: "0px" },
            },
          }}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidthExpanded,
            },
          }}
        >
          {mobileDrawer}
        </Drawer>

        {/* Desktop Drawer - Permanent (Above 600px) */}
        <Drawer
          variant="permanent"
          PaperProps={{
            sx: {
              backgroundColor: "drawerColor.main",
              // marginTop: { xs: "46px", sm: "46px" },
              marginTop: { xs: "46px", sm: "46px" },
              overflowX: "hidden",
            },
          }}
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              transition: "width 0.3s ease",
            },
          }}
        >
          {desktopDrawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 2,
          width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
          transition: "width 0.3s ease",
          overflow: "hidden",
        }}
      >
        <Toolbar />
        {props.children}
      </Box>
    </Box>
  );
}

export default LeftDrawer;
